import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { patientDetailsPath, patientHistoryPath } from 'src/app/utils/routing.utils';
import { RouterModule, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';
import { CommonModule } from '@angular/common';
import { PatientRecordIconComponent } from '@shared/components/patient-record-icon/patient-record-icon.component';

@Component({
  selector: 'stx-patient-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './patient-link.component.html',
  imports: [RouterLink, PatientRecordIconComponent]
})
export class PatientLinkComponent {
  @Input() patientId: string;
  @Input() patientHistoryRoute: boolean;
  @Input() showIcon = true;

  get patientDetailsRoutePath(): string {
    return patientDetailsPath(this.patientId);
  }

  get patientHistoryRoutePath() {
    return patientHistoryPath(this.patientId);
  }
}

@NgModule({
  imports: [RouterModule, MatIconModule, GeneralCommonsModule, CommonModule, PatientLinkComponent],
  exports: [PatientLinkComponent]
})
export class PatientLinkComponentModule {}
